export default __webpack_public_path__ + "a03577f0c7aa739e1714b41262c3f1bd.svg";